export const CompetenceType = {
  Strategic: "strategic",
  Common: "common",
};
